// @ts-check
import { Item, TabList, TabPanels, Tabs } from '@adobe/react-spectrum';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { PUBLISHER_TAB_MAP } from '../../../utils/publisher-data';
import PublisherAppsTabContent from './PublisherAppsTabContent';

const tabs = Object.values(PUBLISHER_TAB_MAP);

const PublisherAppsTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTabKey = searchParams.get('tab');

  /** @param {React.Key} newTabKey */
  const onSelectionChange = (newTabKey) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('tab', newTabKey.toString());
    // Reset page when switching tabs.
    if (selectedTabKey) {
      newSearchParams.set('page', '1');
    }
    setSearchParams(newSearchParams);
  };
  return (
    <Tabs
      items={tabs}
      marginTop="-8px"
      selectedKey={selectedTabKey}
      defaultSelectedKey={PUBLISHER_TAB_MAP.APPLICATIONS.id}
      aria-label="Publisher applications and solutions"
      onSelectionChange={onSelectionChange}
    >
      <TabList width="100%" alignSelf="center" justifySelf="center">
        {(item) => <Item>{item.name}</Item>}
      </TabList>
      <TabPanels marginTop="size-250">
        {() => (
          <Item>
            <PublisherAppsTabContent type="ec" />
          </Item>
        )}
      </TabPanels>
    </Tabs>
  );
};

export default PublisherAppsTabs;
